<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <el-select class="max-fill" size="medium" v-model="_value" disabled :placeholder="placeholder" />
    </div>
    <div v-else-if="mode === 'PC' && !readonly">
      <el-select class="max-fill" v-model="_value" size="medium" clearable :placeholder="placeholder" filterable>
        <el-option v-for="(op, index) in finalOptions" :key="op.id" :value="op.id"
          :label="op.locationArea + op.locationName"></el-option>
      </el-select>
    </div>
    <div v-else-if="mode === 'MOBILE' && !readonly">
      <el-select class="max-fill" v-model="_value" size="medium" clearable :placeholder="placeholder" filterable
        ref="select" @focus="clear" @hook:mounted="clear" @visible-change="clear" popper-append-to-body>
        <el-option v-for="(op, index) in finalOptions" :key="op.id" :value="op.id"
          :label="op.locationArea + op.locationName"></el-option>
      </el-select>
    </div>
    <div v-else>
      {{ label }}
    </div>
  </div>
</template>

<script>
import { Field, Popup, Picker, Radio, RadioGroup } from 'vant';
import componentMinxins from '../ComponentMinxins'
import { getLocationList, getRoomById } from '@/api/ops/conService'

export default {
  mixins: [componentMinxins],
  name: "PositionAreaInput",
  components: { Radio, RadioGroup, Picker, Field, Popup },
  props: {
    value: {
      type: Number,
      default: null
    },
    placeholder: {
      type: String,
      default: '请选择选项'
    },
    expanding: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    propValue: {
      type: Object,
      default: () => {
        return {}
      }
    },
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localOptions: [], // 添加本地options存储
      label: '',
      showCloseCar: false,
    }
  },
  computed: {
    // 使用计算属性合并外部options和本地options
    finalOptions() {
      return this.localOptions.length > 0 ? this.localOptions : this.options;
    }
  },
  created() {
    this.getOptions()
    // 确保没有默认选中值
    if (!this.value) {
      this.$set(this, '_value', undefined);
    }
    this.getLabelByValue(this.value)
  },
  methods: {
    getOptions() {
      getLocationList(this.propValue.type).then(res => {
        this.localOptions = res.data.data || [];
        // 确保不设置默认值
        if (this._value) {
          this.$emit('input', undefined);
        }
      }).catch(error => {
        console.error('获取位置列表失败:', error);
        this.localOptions = [];
      });
    },
    getLabelByValue(value) {
      if (!value || value == null) {
        this.label = '';
        return;
      }
      getRoomById(value).then(res => {
        this.label = res.data.data.locationArea + res.data.data.locationName;
        this.$forceUpdate();
      }).catch(error => {
        console.error('获取位置列表失败:', error);
        this.label = '';
      });
    },
    clear(async) {
      this.$nextTick(() => {
        if (!async) {
          // ios 手机有延迟问题
          setTimeout(() => {
            const { select } = this.$refs
            const input = select.$el.querySelector('.el-input__inner')
            // input.addEventListener('focus', () => {
            //   // 使用 scrollIntoView，并配置一些参数以获得更好的体验
            //   input.scrollIntoView({
            //     behavior: 'smooth', // 平滑滚动
            //     block: 'center', // 垂直居中
            //     inline: 'nearest' // 水平方向最近边缘
            //   });
            // })
            input.removeAttribute('readonly')
          }, 200)
        }
      })
    }
  }
}
</script>

<style>
/* to fix 在ios设备中，el-select组件下拉框，点击2次才能选中问题。 */
.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
</style>
